import { useState } from "react";
import { LegalLayout } from "@/components/LegalLayout";
import { CaretDown } from "@phosphor-icons/react";
import { BUSINESS } from "@/lib/site";

const FAQS = [
  { q: "Bagaimana cara membeli tiket?", a: "Pilih acara di halaman utama, tentukan jenis dan jumlah tiket, isi data pemesan, lalu lanjutkan ke pembayaran. Setelah pembayaran berhasil, E-Ticket otomatis terbit." },
  { q: "Metode pembayaran apa saja yang tersedia?", a: "Kami mendukung iPaymu (Virtual Account, QRIS, dan kartu lokal) serta Stripe (kartu kredit/debit internasional). Anda dapat memilih metode saat checkout." },
  { q: "Bagaimana saya menerima E-Ticket?", a: "E-Ticket tersedia di menu \"Tiket Saya\" segera setelah pembayaran terkonfirmasi, dan salinannya juga dikirim ke email Anda. Setiap tiket memiliki QR Code unik." },
  { q: "Apakah QR Code tiket bisa dipalsukan?", a: "Setiap tiket memiliki token acak yang unik. QR Code hanya dapat digunakan satu kali; setelah dipindai petugas, statusnya berubah menjadi sudah digunakan." },
  { q: "Bagaimana jika QR Code sudah dipindai/digunakan?", a: "Sistem akan menolak pemindaian kedua dan menampilkan status \"Tiket Sudah Digunakan\". Pastikan tiket Anda tidak dibagikan ke orang lain." },
  { q: "Bisakah saya mengunduh tiket sebagai PDF?", a: "Ya. Pada halaman \"Tiket Saya\", buka tiket lalu klik \"Cetak Tiket (PDF)\" untuk mengunduh versi cetak lengkap dengan QR Code." },
  { q: "Apakah tiket bisa direfund?", a: "Kebijakan refund mengikuti Kebijakan Refund kami. Umumnya refund penuh diberikan bila acara dibatalkan oleh penyelenggara. Silakan baca halaman Kebijakan Refund untuk detailnya." },
  { q: "Saya butuh bantuan, ke mana harus menghubungi?", a: `Hubungi kami di ${BUSINESS.email} atau telepon/WhatsApp ${BUSINESS.phone} pada jam layanan ${BUSINESS.hours}.` },
];

function FAQItem({ q, a, idx }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-white/10 bg-card">
      <button data-testid={`faq-item-${idx}`} onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-4 p-4 text-left">
        <span className="font-semibold text-white">{q}</span>
        <CaretDown size={18} className={`text-primary shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-4 pb-4 text-sm text-zinc-400 leading-relaxed">{a}</div>}
    </div>
  );
}

export default function FAQ() {
  return (
    <LegalLayout title="FAQ" subtitle="Pertanyaan yang sering diajukan seputar pembelian tiket, E-Ticket, pembayaran, dan validasi kehadiran.">
      <div className="space-y-3">
        {FAQS.map((f, i) => <FAQItem key={i} q={f.q} a={f.a} idx={i} />)}
      </div>
    </LegalLayout>
  );
}
